import { ResolveFn } from '@angular/router';
import { Programs } from '../../../models/programs/programs';
import { inject } from '@angular/core';
import { ProgramsService } from '../../services/programs/programs.service';
import { GenericStateService } from '../../services/utility-services/generic-state.service';
import { of, take, tap } from 'rxjs';

export const ProgramsResolver: ResolveFn<Programs[]> = (route, state) => {
  const programsStateService = inject(GenericStateService);
  const existingData = programsStateService.getData()?.programs;
  if(existingData){
    return of(existingData);
  }
  else{
    return inject(ProgramsService).getPrograms().pipe(
      tap(data =>{
        programsStateService.setData({"programs": data})
      }),
      take(1)
    );
  }
};
